import { axiosInstance } from './axiosInstance';

import { ROLE_VALUES } from '../../constants/customerConstant';


const UserRoleList = async (userType: number | null) => {
  const { TENANT_USER, TENANT_ADMIN, EXTERNAL_USER, PARTNER_USER, PARTNER_ADMIN } = ROLE_VALUES;

  if (userType) {
    try {
      const userRoleValueResponse = await axiosInstance().get('/user-types');

      switch (userType) {
        case TENANT_USER:
          return userRoleValueResponse.data.filter(
            (item: { value: number; type: string }) =>
              item.value === TENANT_USER || item.value === TENANT_ADMIN || item.value === EXTERNAL_USER,
          );
        case TENANT_ADMIN:
          return userRoleValueResponse.data.filter(
            (item: { value: number; type: string }) =>
              item.value === TENANT_USER || item.value === TENANT_ADMIN || item.value === EXTERNAL_USER,
          );
        case EXTERNAL_USER:
          return userRoleValueResponse.data.filter(
            (item: { value: number; type: string }) =>
              item.value === TENANT_USER || item.value === TENANT_ADMIN || item.value === EXTERNAL_USER,
          );
        case PARTNER_USER:
          return userRoleValueResponse.data.filter(
            (item: { value: number; type: string }) =>
              item.value === PARTNER_USER,
          );
        case PARTNER_ADMIN:
          return userRoleValueResponse.data.filter(
            (item: { value: number; type: string }) =>
              item.value === PARTNER_USER || item.value === PARTNER_ADMIN,
          );
        default:
          return userRoleValueResponse.data.filter(
            (item: { value: number; type: string }) =>
              item.value === TENANT_USER,
          );
      }
    } catch (error) {
      return {
        errorType: true,
        message: `Error fetching department data: ${error}`,
      };
    }
  }
};

export default UserRoleList;